<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs24 sm12>
        <p class="text-xs-center subheading">
          {{ $t('message.instructions.achInfo') }}
        </p>

        <v-flex
          v-show="
            this.$store.getters.getDealerApplication.eftAuthorizationOfficer
          "
          class="elevation-3"
        >
          {{ $t('message.instructions.achLegal1') }}
          <v-tooltip bottom>
            <v-btn
              class="changeAuthorizeBtn"
              slot="activator"
              icon
              @click="openAchAuthorizeDialog(true)"
            >
              <img src="static/icons/create_gray.png" width="22" />
            </v-btn>
            <span>{{ $t('message.updateAuthorizingOfficer') }}</span>
          </v-tooltip>

          <b>
            {{
              this.$store.getters.getDealerApplication.eftAuthorizationOfficer
            }}
          </b>

          <span
            class="text-xs-center"
            v-html="
              $t('message.instructions.achLegal2', [
                this.$store.getters.getDealerApplication.name
              ])
            "
          ></span>

          <v-tooltip top v-show="this.$store.getters.getAchAccounts.length > 0">
            <v-btn
              flat
              v-if="this.$store.getters.isTDComplete"
              slot="activator"
              class="btn-secondary"
              @click="downloadAchTerms"
              :disabled="saveDisabled"
              >Download Terms</v-btn
            >
            <v-btn
              flat
              v-else
              slot="activator"
              class="btn-secondary"
              @click="downloadAchTerms"
              :disabled="saveDisabled"
              >Download Terms</v-btn
            >
            <span>Download PDF of signed terms</span>
          </v-tooltip>
        </v-flex>
      </v-flex>

      <v-layout row wrap class="btn-wrapper">
        <v-dialog
          v-model="achDialog"
          @keydown.esc="achDialog = false"
          persistent
          max-width="500px"
        >
          <v-btn
            v-show="
              this.$store.getters.getAchAccounts &&
                this.$store.getters.getAchAccounts.length != 0
            "
            slot="activator"
            class="btn-primary"
          >
            <img src="static/icons/add_white.png" width="24" />
            {{ $t('message.achInfo') }}
          </v-btn>
          <v-form
            ref="achForm"
            v-model="valid"
            @keydown="errors.clear($event.target.name)"
          >
            <v-card>
              <v-flex
                xs12
                v-show="loading"
                class="grey"
                style="opacity:50%;position: absolute;width: 100%;height: 100%;"
              >
                <v-progress-circular
                  style="width: 100%;"
                  :size="70"
                  :width="8"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-flex>
              <v-card-title>
                <span v-if="achIndex == -1" class="headline">{{
                  $t('message.newAchInfo')
                }}</span>
                <span v-else class="headline">{{
                  $t('message.updateAchInfo')
                }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md class="no-top-padding">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        v-model="achAccount.bankName"
                        :rules="bankNameRules"
                        :label="$t('message.ach.bankName')"
                        validate-on-blur
                        required
                        maxlength="30"
                        :counter="30"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex sm12>
                      <v-text-field
                        v-model="achAccount.addressStreet"
                        :rules="addressRules"
                        :label="$t('message.ach.bankAddress')"
                        validate-on-blur
                        maxlength="30"
                        :counter="30"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="achAccount.addressCity"
                        :rules="cityRules"
                        :label="$t('message.city')"
                        validate-on-blur
                        required
                        maxlength="20"
                        :counter="20"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4 sm2>
                      <v-text-field
                        v-model="achAccount.addressState"
                        :rules="stateRules"
                        :mask="stateMask"
                        :label="$t('message.state')"
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs8 sm4>
                      <v-text-field
                        v-model="achAccount.addressZipCode"
                        :rules="zipCodeRules"
                        :mask="zipMask"
                        :label="$t('message.zipCode')"
                        validate-on-blur
                        type="tel"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="achAccount.phoneNumber"
                        :rules="phoneRules"
                        :label="$t('message.bankPhoneNumber')"
                        :mask="phoneMask"
                        validate-on-blur
                        type="tel"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="achAccount.contactName"
                        :rules="contactNameRules"
                        :label="$t('message.ach.contactName')"
                        validate-on-blur
                        maxlength="30"
                        :counter="30"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="achAccount.routingNumber"
                        :rules="routingNumberRules"
                        :label="$t('message.ach.routingNumber')"
                        :mask="numberMask9"
                        validate-on-blur
                        type="tel"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="achAccount.accountNumber"
                        :rules="accountNumberRules"
                        :label="$t('message.ach.accountNumber')"
                        maxlength="17"
                        minlength="7"
                        :mask="numberMask17"
                        validate-on-blur
                        type="tel"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  class="btn-secondary"
                  @click.native="closeAchDialog"
                  >{{ $t('message.cancel') }}</v-btn
                >
                <v-btn
                  flat
                  class="btn-primary"
                  v-show="this.achIndex == -1"
                  @click="saveAchInfo"
                  :disabled="saveDisabled"
                  >{{ $t('message.add') }}</v-btn
                >

                <v-tooltip top>
                  <v-btn
                    flat
                    slot="activator"
                    class="btn-primary mx-1"
                    v-show="this.achIndex != -1"
                    @click="saveAchInfo"
                    :disabled="saveDisabled"
                    >{{ $t('message.save') }}</v-btn
                  >
                  <span>{{ $t('message.saveAndResume') }}</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-layout>

      <v-dialog
        v-model="achAuthorizeDialog"
        @keydown.esc="achAuthorizeDialog = false"
        persistent
        max-width="500px"
      >
        <v-form
          ref="achAuthorizeForm"
          v-model="achAuthorizeValid"
          @keydown="errors.clear($event.target.name)"
        >
          <v-card>
            <v-flex
              xs12
              v-show="loading"
              class="grey"
              style="opacity:50%;position: absolute;width: 100%;height: 100%;"
            >
              <v-progress-circular
                style="width: 100%;"
                :size="70"
                :width="8"
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-flex>
            <v-card-title>
              <v-flex>
                {{ $t('message.instructions.achLegal1') }}
                <b>
                  {{
                    this.$store.getters.getDealerApplication
                      .eftAuthorizationOfficer
                  }}
                </b>

                <span
                  class="text-xs-center"
                  v-html="
                    $t('message.instructions.achLegal2', [
                      this.$store.getters.getDealerApplication.name
                    ])
                  "
                ></span>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md class="no-top-padding">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="achAuthorizeName"
                      :label="$t('message.ach.officer')"
                      :rules="authorizeNameRules"
                      validate-on-blur
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                flat
                class="btn-secondary"
                @click.native="achAuthorizeDialog = false"
                >{{ $t('message.cancel') }}</v-btn
              >

              <v-btn
                flat
                slot="activator"
                class="btn-primary"
                @click="saveAchAuthorizeName"
                :disabled="saveDisabled"
                >{{ $t('message.save') }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-container
        grid-list-md
        v-if="this.$store.getters.getAchAccounts.length > 0"
      >
        <v-data-table
          :headers="headers"
          :items="this.$store.getters.getAchAccounts"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.bankName }}</td>
            <td class="hidden-sm-and-down">
              {{ props.item.accountNumber | maskedNumberFilter }}
            </td>
            <td>
              <v-flex v-if="props.item.docUploadDate">
                {{ formatDate(props.item.docUploadDate) }}
              </v-flex>
              <v-flex v-else>
                <p class="font-weight-bold">Upload voided check to proceed</p>
              </v-flex>
            </td>
            <td>
              <v-tooltip bottom class="text-xs-left">
                <v-flex row wrap class="btn-wrapper" slot="activator">
                  <label :for="'id'+props.item.id">
                    <img
                      src="static/icons/cloud_upload_blue.png"
                      width="44"
                      style="cursor: pointer;"
                    />
                  </label>
                  <input
                    type="file"
                    :id="'id'+props.item.id"
                    :name="'name'+props.item.id"
                    multiple
                    :accept="fileUploadValidTypes"
                    @change="
                      handleFileUpload(
                        $event.target.name,
                        $event.target.files,
                        props.item
                      )
                    "
                  />
                </v-flex>
                <span>{{ $t('message.upload') }}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-right" nowrap>
              <v-tooltip bottom>
                <v-btn slot="activator" icon @click="editAchDialog(props.item)">
                  <img src="static/icons/create_gray.png" width="26" />
                </v-btn>
                <span>{{ $t('message.edit') }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  @click="remove(props.item)"
                  icon
                  class="grey--text"
                >
                  <img src="static/icons/delete_gray.png" width="26" />
                </v-btn>
                <span>{{ $t('message.remove') }}</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-container>
      <empty-list
        v-if="this.$store.getters.getAchAccounts.length == 0"
        v-bind:message="$t('message.achInfo')"
        @clicked="openAppropriateDialog()"
      ></empty-list>
    </v-layout>
  </v-container>
</template>

<script>
import { axiosAuthInstance } from '../../main.js'
import EmptyList from '../util/EmptyList'

export default {
  data: () => ({
    fileUploadValidTypes: ".pdf,application/pdf,*.jpg,image/jpg,.jpeg,/image/jpeg,.png,image/png",
    achAccount: {},
    achIndex: -1,
    headers: [
      { text: 'Order', value: 'order', sortable: false, width: '8%' },
      { text: 'Bank Name', value: 'bankName', sortable: false },
      {
        text: 'Account Number',
        value: 'accountNumber',
        class: 'hidden-sm-and-down',
        sortable: false,
        width: '14%'
      },
      { text: 'Check Upload', value: 'docUploadDate', sortable: false },
      { text: '', value: 'docUploadDate', sortable: false, width: '10%' },
      { value: '', sortable: false, width: '15%' }
    ],
    valid: true,
    saveDisabled: false,
    achDialog: false,
    achAuthorizeDialog: false,
    achAuthorizeDialogStandalone: false,
    achAuthorizeName: null,
    achAuthorizeValid: false,
    loading: false,
    routingNumberRules: [
      v => !!v || 'Routing number is required',
      v => (v && v.length == 9) || 'Routing number must be 9 characters'
    ],
    bankNameRules: [v => !!v || 'Bank name is required'],
    authorizeNameRules: [v => !!v || 'Officer name is required']
  }),
  methods: {
    saveAchAuthorizeName() {
      if (this.$refs.achAuthorizeForm.validate()) {
        var dealerApplication = this.$store.getters.getDealerApplication
        dealerApplication.eftAuthorizationOfficer = this.achAuthorizeName

        this.achAuthorizeDialog = false

        axiosAuthInstance
          .post('api/v1/dealerApp/update', dealerApplication)
          .then(response => {
            this.notifyInfo('ACH authorization saved')
            if( !this.achAuthorizeDialogStandalone ){
              this.openAppropriateDialog();
            }
          })
          .catch(error => {
            this.notifyAxiosError(error, 'There was an error updating the ACH')
          })
      }
    },
    saveAchInfo() {
      if (this.checkAndConfirmInvalidate() && this.$refs.achForm.validate()) {
        this.saveDisabled = true
        this.loading = true
        var tempAchAccount = Object.assign({}, this.achAccount)
        tempAchAccount.applicationId = this.$store.getters.getApplicationId

        var isUpdate = this.achIndex > -1
        var serviceMethod = isUpdate ? 'update' : 'create'
        axiosAuthInstance
          .post('api/v1/ach/' + serviceMethod, tempAchAccount)
          .then(response => {
            if (this.achIndex > -1) {
              this.$store.getters.getAchAccounts[this.achIndex] = Object.assign(
                this.$store.getters.getAchAccounts[this.achIndex],
                tempAchAccount
              )
            } else {
              this.$store.getters.getAchAccounts.push(response.data)
              this.checkFormComplete()
            }
            this.closeAchDialog()

            if (tempAchAccount.docUploadDate) {
              this.notifyInfo('ACH info saved')
            } else {
              this.notifyWarn(
                'ACH info saved',
                'Please upload a voided check on the ACH INFO tab.',
                -1
              )
            }
          })
          .catch(error => {
            this.notifyAxiosError(error, 'Save ACH failed')
          })
          .then(() => {
            if (this.$store.getters.isApplicationJustInvalidated) {
              this.$store.commit('setApplicationJustInvalidated', false)
              this.$router.go() //reload to pick up all server side changes
            } else {
              this.loading = false
              this.saveDisabled = false
            }
          })
      }
    },
    handleFileUpload(fieldName, fileList, inAchInfo) {
      const file = fileList[0]

      if (file) {
        this.loading = true
        var fileFormData = new FormData()
        fileFormData.append('file', file)
        this.$store.commit('setLoading', true)
        axiosAuthInstance
          .post('api/v1/ach/uploadDoc/' + inAchInfo.id, fileFormData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(response => {
            var tempAchIndex = this.$store.getters.getAchAccounts.indexOf(
              inAchInfo
            )
            this.$store.getters.getAchAccounts[tempAchIndex].docFilename =
              file.name
            this.$store.getters.getAchAccounts[
              tempAchIndex
            ].docUploadDate = this.currentDateForJson()
            this.notifyInfoAndClear('File uploaded')
            this.checkFormComplete()
          })
          .catch(error => {
            this.notifyAxiosError(error, 'ACH file upload failed')
          })
          .then(() => {
            this.loading = false
            this.$store.commit('setLoading', false)
          })
      }
    },
    openAppropriateDialog() {
      if (this.$store.getters.getDealerApplication.eftAuthorizationOfficer) {
        this.achDialog = true
      } else {
        this.openAchAuthorizeDialog()
      }
    },
    openAchAuthorizeDialog(standAlone) {
      this.achAuthorizeName = this.$store.getters.getDealerApplication.eftAuthorizationOfficer
      this.achAuthorizeDialog = true
      this.achAuthorizeDialogStandalone = standAlone
    },
    closeAchDialog() {
      this.achDialog = false
      setTimeout(() => {
        this.$refs.achForm.reset()
        this.achIndex = -1
        this.saveDisabled = false
        this.loading = false
      }, 200)
    },
    editAchDialog(inAchInfo) {
      this.achIndex = this.$store.getters.getAchAccounts.indexOf(inAchInfo)
      this.achAccount = Object.assign({}, inAchInfo)
      this.saveDisabled = false
      this.achDialog = true
    },
    remove(inAchInfo) {
      if (confirm('Are you sure you want to remove this ACH Account?')) {
        axiosAuthInstance
          .delete('api/v1/ach/', { data: inAchInfo })
          .then(response => {
            const index = this.$store.getters.getAchAccounts.indexOf(inAchInfo)
            this.$store.getters.getAchAccounts.splice(index, 1)
            this.checkFormComplete()
          })
          .catch(error => {
            this.notifyAxiosError(error, 'Delete ACH failed')
          })
          .then(() => {
            if (this.$store.getters.getAchAccounts.length == 0) {
              //if all are removed, reset the ACH auth name
              this.$store.getters.getDealerApplication.eftAuthorizationOfficer =
                ''
              this.saveAchAuthorizeName()
            }
          })
      }
    },
    checkFormComplete() {
      var completeForm = false

      //these aren't required, but if present, need files uploaded
      if (this.$store.getters.getAchAccounts.length > 0) {
        completeForm = true
        for (var i = 0; i < this.$store.getters.getAchAccounts.length; i++) {
          if (
            !this.$store.getters.getAchAccounts[i].docFilename &&
            !this.$store.getters.getAchAccounts[i].docUploadDate
          ) {
            completeForm = false
            break
          }
        }
      }

      this.$store.commit('setAchComplete', completeForm)
    }
  },
  mounted() {
    axiosAuthInstance
      .get('api/v1/ach/application/' + this.$store.getters.getApplicationId)
      .then(response => {
        if (response.data && response.data.length > 0) {
          this.$store.commit('setAchAccounts', response.data)
        }
        this.checkFormComplete()
      })
      .catch(error => {
        this.notifyAxiosError(error, 'Failed to fetch ACH data')
      })
  },
  components: {
    'empty-list': EmptyList
  }
}
</script>

<style>
  .error-message {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/Application/AchInfo.vue